import { Box, Button, Divider, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router-dom';
import { EnquiryDetail } from '../../services/sellOldAC';
import { useEffect, useState } from 'react';
import { ISellOldACDetail } from '../../utils/entities/interface';
import { Engineering, RemoveRedEyeOutlined } from '@mui/icons-material';
import AssignTechnicianModal from '../Booking/actions/TechnicianModal';

function SellRequestDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const [detailValue, setDetailValue] = useState<ISellOldACDetail | null>(null);
  const [assignModal, setAssignModal] = useState<boolean>(false);

  useEffect(() => {
    fetchDetail();
  }, []);

  async function fetchDetail() {
    await EnquiryDetail(location?.state).then((response) => {
      setDetailValue(response.data);
    });
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        maxHeight: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          mb: 3,
          mt: 3,
          pl: 2,
        }}
      >
        <IconButton onClick={() => navigate(-1)} sx={{ color: '#fff' }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography sx={{ color: '#fff', fontSize: 26, fontWeight: 600 }}>
          Request Details
        </Typography>
      </Box>

      <Divider sx={{ marginBottom: 3 }} />

      <div className="px-5">
        <div className="w-full mx-auto bg-[#1a1a1a] rounded-xl shadow-lg border border-[#2a2a2a]">
          <div className="flex justify-between items-center px-6 py-4 border-b border-[#2a2a2a]">
            <div className="flex items-center gap-2 text-lg font-medium text-white">
              Customer Details
            </div>

            <div className="text-sm text-white">
              Status :
              <span className="text-green-500 font-medium ml-1">
                {detailValue?.status}
              </span>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 px-6 py-6 text-sm bg-[#232323]">
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <p className="text-gray-400 w-full">Full Name</p>
                <p className="text-green-500 underline w-full">
                  {detailValue?.user_info?.name}
                </p>
              </div>

              <div className="flex items-center justify-between">
                <p className="text-gray-400 w-full">Customer Type</p>
                <p className="w-full text-white">-</p>
              </div>

              <div className="flex items-center justify-between">
                <p className="text-gray-400 w-full">Address</p>
                <p className="w-full text-white">
                  {detailValue?.addressDetails?.house},{' '}
                  {detailValue?.addressDetails?.street},{' '}
                  {detailValue?.addressDetails?.city},{' '}
                  {detailValue?.addressDetails?.state},{' '}
                  {detailValue?.addressDetails?.zipcode}
                </p>
              </div>

              <div className="flex items-center justify-between">
                <p className="text-gray-400 w-full">Total AC</p>
                <p className="w-full text-white">{detailValue?.noOfAc}</p>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <p className="text-gray-400 w-full">Contact Number</p>
                <p className="w-full text-white">
                  {detailValue?.user_info?.phoneNumber}
                </p>
              </div>

              <div className="flex items-center justify-between">
                <p className="text-gray-400 w-full">Inspection Date</p>
                <p className="w-full text-white">
                  {detailValue?.schedule?.date
                    ? new Date(detailValue.schedule.date).toLocaleDateString()
                    : '-'}
                </p>
              </div>

              <div className="flex items-center justify-between">
                <p className="text-gray-400 w-full">Inspection Time</p>
                <p className="w-full text-white">
                  {detailValue?.schedule?.slot}
                </p>
              </div>

              <div className="flex items-center justify-between">
                <p className="text-gray-400 w-full">Inspection Address</p>
                <p className="w-full text-white">
                  {detailValue?.addressDetails?.saveAs}
                </p>
              </div>

              <div className="flex items-center justify-between">
                <p className="text-gray-400 w-full">Assign Inspector</p>
                {detailValue?.technician_info ? (
                  <p className="w-full text-white flex items-center justify-between">
                    {detailValue?.technician_info?.name}{' '}
                    <RemoveRedEyeOutlined
                      onClick={() => {
                        navigate(
                          `/technicians/${detailValue?.technician_info?._id}`,
                        );
                      }}
                      style={{ color: 'red', cursor: 'pointer' }}
                    />
                  </p>
                ) : (
                  <p className="w-full text-white flex items-center justify-between">
                    -
                  </p>
                )}
              </div>
            </div>
          </div>

          {detailValue?.oldAcDetails?.map((ac, index) => (
            <div key={ac._id}>
              <div className="border-t border-[#2a2a2a]" />

              <div className="px-6 py-5">
                <h3 className="text-white text-sm mb-4">
                  AC Details {index + 1}
                </h3>

                <div className="grid grid-cols-2 gap-8 text-sm">
                  <div className="space-y-4">
                    <div className="flex items-center justify-between">
                      <p className="text-gray-400 w-full">Brand</p>
                      <p className="w-full text-white">{ac?.brand}</p>
                    </div>

                    <div className="flex items-center justify-between">
                      <p className="text-gray-400 w-full">AC Type</p>
                      <p className="w-full text-white">{ac?.acType}</p>
                    </div>
                  </div>

                  <div className="space-y-4">
                    <div className="flex items-center justify-between">
                      <p className="text-gray-400 w-full">AC Technology</p>
                      <p className="w-full text-white">{ac?.technology}</p>
                    </div>

                    <div className="flex items-center justify-between">
                      <p className="text-gray-400 w-full">Tonnage</p>
                      <p className="w-full text-white">{ac?.tonnage}</p>
                    </div>

                    <div className="flex items-center justify-between">
                      <p className="text-gray-400 w-full">Condition</p>
                      <p className="w-full text-white">{ac?.condition}</p>
                    </div>
                  </div>
                </div>

                {ac?.photos?.length > 0 && (
                  <div className="grid grid-cols-2 gap-6 mt-6">
                    {ac.photos.map((img, i) => (
                      <img
                        key={i}
                        src={img}
                        alt="AC"
                        className="rounded-xl object-cover h-56 w-full"
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 flex justify-end">
          {!detailValue?.technician_info ? (
            <Button
              sx={{
                color: '#fff',
                backgroundColor: '#7B1FA2',
                '&:hover': { backgroundColor: '#7B1FA2' },
                padding: '10px 20px',
                borderRadius: '14px',
              }}
              startIcon={<Engineering />}
              //   onClick={handleCreateBooking}
              onClick={() => setAssignModal(true)}
            >
              Assign Inspector
            </Button>
          ) : (
            ''
          )}
        </div>
      </div>
      <AssignTechnicianModal
        isOpen={assignModal}
        onClose={() => setAssignModal(false)}
        bookingId={location?.state}
        onReload={fetchDetail}
        isEnquiry={true}
      />
    </Box>
  );
}

export default SellRequestDetail;
